import React from 'react';
import IconImageVideo from 'js/components/icon_image-video';

import 'scss/layout.scss';
import './index.scss';

export default function NoSubmittedContent() {
    return (
        <div className='no-submitted-content__wrapper'>
            <div className="no-submitted-content__caption">
                <IconImageVideo/>
                <p className="no-submitted-content__text">
                   Content will be available for review once submitted by creators.
                </p>
                <p className="no-submitted-content__text">
                    Please check back soon.
                </p>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./components/no_submitted_content/index.js